import * as Sentry from '@sentry/react';
import { TsGpsPoint } from 'seacube-backend/src/api/client';

import { zoomToTimeSpan } from '../utils/mapbox';

import { store } from './store';

export const setGpsData = (gpsData: TsGpsPoint[]) => {
  store.gpsData.raw = gpsData;
};

export const setGpsDataFiltered = () => {
  if (!store.tsFilterRange || !store.gpsData) return;
  const min = store.tsFilterRange[0];
  const max = store.tsFilterRange[1];
  store.gpsData.filtered = store.gpsData.raw.filter(
    (p: TsGpsPoint) => p.timestamp >= min && p.timestamp <= max,
  );
};

export const setGpsProgress = () => {
  if (!store.gpsData.filtered.length) return 0;
  if (!store.gpsData.highlightedIndex) return 0;
  store.tripFooter.progress =
    (store.gpsData.highlightedIndex / store.gpsData.filtered.length) * 100;
};

export const setHighlightedGpsDataFilteredIndex = ({
  timestamp,
  index,
}: {
  timestamp?: number;
  index?: number;
}) => {
  // Trouver l'index le plus proche
  if (index) {
    store.gpsData.highlightedIndex = index;
    setGpsProgress();
    return;
  }
  if (timestamp) {
    if (!store.gpsData.filtered || store.gpsData.filtered.length === 0) {
      Sentry.captureException('gpsData.filtered is empty');
      return;
    }
    const closestIndex = store.gpsData.filtered.reduce(
      (acc, current, currentIndex) => {
        const currentDiff = Math.abs(current.timestamp - timestamp);
        if (currentDiff < acc.closestDiff) {
          return {
            closestDiff: currentDiff,
            index: currentIndex,
          };
        }
        return acc;
      },
      {
        closestDiff: Math.abs(store.gpsData.filtered[0].timestamp - timestamp),
        index: 0,
      },
    ).index;

    store.gpsData.highlightedIndex = closestIndex;
    setGpsProgress();
    return;
  }
};

export const resetHighlightedGpsDataFilteredIndextGps = () => {
  store.gpsData.highlightedIndex = undefined;
};
export const zoomToGpsDataFiltered = (mapRef: any) => {
  zoomToTimeSpan({
    mapRef,
    gpsData: store.gpsData.filtered,
  });
};
